// import AuthRoutes from './data/AuthRoutes'
import BaseRoutes from "./data/BaseRoutes";
import AuthRoutes from "./data/AuthRoutes";

export default [...AuthRoutes, ...BaseRoutes];
